import { fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";
import type {
  ElectronicFormRequest,
  ElectronicFormRequestFormKit,
  ElectronicFormRequestNew,
} from "@/views/electronicFormRequest/electronicFormRequest";
import { LE } from "@/constants/enums";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: ElectronicFormRequest) {
  entity._authRequestFields = ["id", "statusMurn", "typeMurn"];
  return entity;
}

function getInitialData() {
  const result = {} as ElectronicFormRequest; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: ElectronicFormRequest }) {
  await fillLookupValuesByPropertyNames(response.data, ["typeMurn", "statusMurn"]);
  addAuthRequestFields(response.data);

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: ElectronicFormRequest }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: ElectronicFormRequestFormKit) {
  if (data.isApproved === true) {
    data.statusMurn = LE.ElectronicFormRequestStatus.Approved;
  } else if (data.isApproved === false) {
    data.statusMurn = LE.ElectronicFormRequestStatus.Denied;
  }
  delete data.isApproved;
  delete data.status;
  delete data.type;
  delete data.electronicForm;

  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends ElectronicFormRequest | ElectronicFormRequestNew>(data: T) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: ElectronicFormRequest) {}
